<template>
    <div class="flex justify-center text-sm text-gray-600">
      <label for="file-upload" class="cursor-pointer w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:ml-3 sm:w-auto sm:text-sm">
        <span>Upload a file</span>
        <input id="file-upload" name="file-upload" ref="fileUpload" type="file" class="sr-only" @change="uploadFile">
      </label>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useDocumentsStore } from '../../stores/documentsStore';

export default {
    props: {
        attachableType: {
            type: String,
            required: true
        },
        attachableId: {
            type: Number,
            required: true
        },
        supportedtypes: {
            type: String,
            default: "PDF, DOC, DOCX, PNG, JPG, ZIP, XLS, XLSX, PPT, PPTX"
        }
    },
    computed: {
        ...mapStores(useDocumentsStore)
    },
    data: function () {
        return {
            file: null
        }
    },
    methods: {
        uploadFile() {
            this.file = this.$refs.fileUpload.files[0];
            if(this.file){
                this.submitFile();
            } 
            else{
                console.error("No file selected");
            }
        },
        async submitFile() {
            try{
                await this.documentsStore.uploadDocument(this.file, this.attachableId, this.attachableType);
                this.$refs.fileUpload.value = '';
                this.file = null;
            }
            catch(e){
                console.log(e);
            }
          }
    }
}
</script>
